// extracted by mini-css-extract-plugin
module.exports = {"Content":"BlogDetail_Content__C7riv"};